<template>
	<b-modal
		scrollable
		no-fade
		ok-only
		ok-title="Actualizar"
		title="Calcular y actualizar pickup"
		static
		id="calculate-massive-pickups"
		size="xl"
		body-class="position-static"
		@ok="onSubmit"
		@show="onShow"
		>
		<b-overlay :show="loading" no-wrap rounded></b-overlay>
			<p class="col-12" v-if="selected.length>0">
				Se realizara el calculo de {{countSelected}} servicios de transporte
			</p>
			<p v-else>
				No has seleccionado algún registro
			</p>
			<div class="col-12" v-if="selected.length > 0">
				<b-row class="mt-2">
					<b-col cols="3">
						<b-form-group id="input-group-1" label-for="input-1">
							<label class="mr-sm-2">Minutos pickup aeropuerto</label>
							<b-form-input v-model="extraMinutesArrival" type="number" min="0" value="0"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="3">
						<b-form-group id="input-group-1" label-for="input-1">
							<label class="mr-sm-2">Minutos adicionales salidas</label>
							<b-form-input v-model="extraMinutesDeparture" type="number" min="0" value="0"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
			</div>
			<div v-if="updated.length>0">
				<h4>Servicios actualizados con éxito</h4>
				<b-table
					hover
					:items="updated"
					:fields="columns"
					striped
					bordered
					small
					show-empty
					>
						<template #cell(actions)="row">
							<div class="d-flex">
								<b-button @click="(event) => resView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="visibility"></md-icon>
								</b-button>
							</div>
						</template>
				</b-table>
			</div>
			<div v-if="fails.length>0">
				<h4>Servicios que no pudieron ser actualizados</h4>
				<b-table
					hover
					:items="fails"
					:fields="columns"
					striped
					bordered
					small
					show-empty
					>
						<template #cell(actions)="row">
							<div class="d-flex">
								<b-button @click="(event) => resView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="visibility"></md-icon>
								</b-button>
							</div>
						</template>
				</b-table>
			</div>
	</b-modal>
</template>

<script>
import api from '../../../api.js'

export default {
	methods: {
		onShow() {
			this.fails = []
			this.updated = []
		},
		onSubmit(event) {
			event.preventDefault()
			this.loading = true
			this.fails = []
			this.updated = []
			api(this).post(`/transport-services/massive-update-pickups`, {
				ids:this.selected,
				extraMinutesArrival: this.extraMinutesArrival,
				extraMinutesDeparture: this.extraMinutesDeparture
			} ).then((res) => {
				this.$root.showAlert('Actualización finalizada');
				this.$emit('update:selected',res.data.fails)
				this.fails = res.data.fails
				this.updated = res.data.updated
				this.$root.$emit('bv::refresh::table', 'reservations-index-list');
				this.loading = false
			}).catch(this.$root.handleRequestError);
		}
	},
	props: {
		selected: {
			type : Array,
			required: true
		},
		resView: {
			type: Function,
			required:true,
		}
	},
	components: {  },
	data(){
		return {
			loading:false,
			fails:[],
			updated:[],
			extraMinutesArrival: 0,
			extraMinutesDeparture: 0,
			columns:[
				{key:'reservationId',label:'Res ID',sortable:true},
				// {key:'clientName',label:'Cliente'},
				{key:'pickup',label:'Pickup'},
				{key:'dropoff',label:'Dropoff'},
				{key:'flightDatetime',label:'Fecha Vuelo',sortable:true},
				{key:'pickupDatetime',label:'Fecha Pickup',sortable:true},
				{key:'serviceType',label:'Tipo servicio'},
				// {key:'salesChannel',label:'Canal de venta'},
				// {key:'salesChannelReference',label:'Referencia'},
				// {key:'supplier',label:'Proveedor'},
				{key:'trip',label:'Viaje'},
				// {key:'status',label:'Estado'},
				// {key:'contactStatus',label:'Contacto'},
				{key:'actions',label:'Acciones'},
			]
		}
	},
	computed:{
		countSelected(){
			return this.selected.length
		},
	},
	mounted(){
	},
	watch:{
	}
}
</script>
